import { render } from "./TotalDistanceHistory.vue?vue&type=template&id=797934ba"
import script from "./TotalDistanceHistory.vue?vue&type=script&lang=js"
export * from "./TotalDistanceHistory.vue?vue&type=script&lang=js"

import "./TotalDistanceHistory.vue?vue&type=style&index=0&id=797934ba&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__